<template>
    <div>
        <div class="bar">
            <a-tooltip placement="top"
                v-for="i of 6" :key="i"
                :title="`${ text[i-1] }: ${ data[i-1] }(${ (data[i-1] * 100 / total).toFixed(2) }%)`"
            >
                <div class="item"
                    :style="{
                        backgroundColor: calColor(i-1),
                        width: `${ data[i-1] * 1000 / total }px`
                    }"
                ></div>
            </a-tooltip>
        </div>
        <div class="intro">
            <span v-for="i of 6" :key="i" class="token">
                <div :style="{ backgroundColor: calColor(i-1) }" class="rect"></div>
                {{ text[i-1] }}
            </span>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        data: Array
    },
    data: () => ({
        text: [
            '<10m', '10~30m', '30m~1h', '1~3h', '3~10h', '>10h',
        ]
    }),
    computed: {
        total() {
            let count = 0;
            for (let i = 0; i < 6; i++) {
                count += this.data[i];
            }
            return count;
        }
    },
    methods: {
        calColor(index) {
            return [
                '#BBDEFB',
                '#90CAF9',
                '#64B5F6',
                '#42A5F5',
                '#1E88E5',
                '#1976D2',
            ][index];
        }
    }
}
</script>

<style lang="less" scoped>
.bar {
    display: flex;
    flex-direction: row;    
    max-width: 90%;
}
.bar, .item {
    height: 16px;
}
.item {
    margin-left: 1px;
}
.intro {
    margin-left: 10px;
}
.rect {
    height: 10px;
    width: 10px;
    border: 1px solid black;
    display: inline-block;
}
</style>